import create from 'zustand';

import focusFilter from '../../../../store/focusFilter';

const useFocusFilterStore = create(focusFilter);

export default useFocusFilterStore;
